/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.15.527 on 2019-07-04 14:53:30.

import {
    AttributeType,
    AttributeUnit,
    BaseQuestionIdentifier,
    CaseStatus,
    CaseType,
    DateElement,
    DisclosurePhysicianIdentifier,
    DisclosureSource,
    DisclosureStatus,
    ExpandedHalResource,
    InterviewDisclosureIdentifier,
    Link,
    ManualDecisionStatus,
    PhysicianAdditionSource,
    PhysicianResourceIdentifier,
    ProcessingStage,
    QuestionAnswerType,
    QuestionType,
    ReflexiveAnswerType,
    ResourceSupport,
    ResultType,
    SingleListIdentifier,
    StageDataAccessType,
    StageType
} from '@Components/mras/core';

export class AttachmentResource extends ExpandedHalResource {
    identifier: string;
    name: string;
    url: string;
    userId: string;
}

export class AttributesResource extends ExpandedHalResource {
    attributes: { [index: string]: string };
    matchBasedAttributes: { [index: string]: { [index: string]: string } };
    riskBasedAttributes: { [index: string]: { [index: string]: string } };
}

export class CaseDataQuestionMeta {
    attributeName: string;
    attributePath: string;
    dataType: AttributeType;
    dateUnitMaximum: DateElement;
    dateUnitMinimum: DateElement;
    list: SingleListIdentifier;
    maximum: number;
    minimum: number;
    properties: { [index: string]: string };
    unit: AttributeUnit;
    usedAsBqFilter: boolean;
    validationMessage: string;
}

export class CaseDecisionResource extends ExpandedHalResource {
    activationDate: string;
    approvedByUser: string;
    attributes: { [index: string]: string };
    comments: DecisionCommentResource[];
    decisionStatus: ListItemResource;
    decisionType: ListItemResource;
    qualification: ListItemResource;
    underwritingStatus: ListItemResource;
}

export class CaseResource extends ExpandedHalResource {
    assignedBy: string;
    assignedUser: string;
    assignedUserReason: string;
    autoUnderwritingStatus: ListItemResource;
    caseCloseReason: string;
    caseId: string;
    caseRushReason: ListItemResource;
    caseStatus: CaseStatus;
    caseStatusReason: ListItemResource;
    caseType: CaseType;
    cashWithApp: boolean;
    configurationVersion: number;
    dateAssigned: string;
    dateClosed: string;
    dateCreated: string;
    dateLastModified: string;
    dateLastUnderwritten: string;
    datePurgedFromEtl: string;
    dateTransferedToDatastream: string;
    dateTransferedToEtl: string;
    dateTransferedToMUW: string;
    externalReference: string;
    hasAttachments: boolean;
    highProfile: boolean;
    interviewTerminated: boolean;
    locale: string;
    manualDecisionStatus: ManualDecisionStatus;
    manualUnderwritingStatus: ListItemResource;
    processingStage: ProcessingStage;
    properties: { [index: string]: string };
    qualityReviewRequired: boolean;
    rulebookCode: string;
    rulesetId: string;
    securityGroup: string;
    underwriterOfRecord: string;
}

export class ConditionDisclosureResource {
    _embedded: { [index: string]: ResourceSupport[] };
    _links: Link[];
    actionsPerRiskType: DisclosureActionForRiskTypeResource[];
    aliasName: string;
    aliasReferenceCode: string;
    autorun: boolean;
    baseQuestionsDisclosures: BaseQuestionIdentifier[];
    category: ListItemResource;
    conditionExternalReference: string;
    conditionName: string;
    createdByUser: string;
    decisionSteps: DecisionStepResource[];
    defaultCondition: boolean;
    disclosurePhysicians: DisclosurePhysicianIdentifier[];
    disclosureType: ListItemResource;
    errorMessage: string;
    hasPhysicians: boolean;
    implicitDisclosureType: ListItemResource;
    manualActionsPerRiskType: DisclosureActionForRiskTypeResource[];
    matchIndex: number;
    note: string;
    physicianCaptureComplete: boolean;
    physicianDetailsRequired: boolean;
    physiciansValid?: boolean;
    questions: ReflexiveQuestionResource[];
    removableFromBqCodes: string[];
    status: DisclosureStatus;
    triggeredCondAlias: string;
    triggeredCondAliases: string[];
    unknown: boolean;
    errorCode?: string;
    message?: string;
}

export class ConditionalQuestionMeta {
    childQuestionCodes: BaseQuestionIdentifier[];
    requiredDisclosureMade: boolean;
    requiresLinkedDisclosure: boolean;
}

export class ConditionsResource extends ExpandedHalResource {
    conditions: string[];
}

export class DecisionByClassResource {
    categoryClass: ListItemResource;
    originalPremiumLoading: number;
    originalSumAssuredLoading: number;
    originalTermedSumAssuredLoadings: TermedLoadingResource[];
    premiumLoading: number;
    resultType: ResultType;
    sumAssuredLoading: number;
    termedSumAssuredLoadings: TermedLoadingResource[];
}

export class DecisionCommentResource {
    date: string;
    text: string;
    type: ListItemResource;
    user: string;
}

export class DecisionStepResource {
    answerText: string;
    answerValue: string;
    isCancelled: boolean;
    isInteractive: boolean;
    knownDataName: string;
    properties: { [index: string]: string };
    questionText: string;
}

export class DisclosureActionForRiskTypeResource {
    disclosureActions: DisclosureActionResource;
    riskType: ListItemResource;
}

export class DisclosureActionResource {
    _embedded: { [index: string]: ResourceSupport[] };
    _links: Link[];
    ageAdjustment: number;
    authorizationLevel: number;
    benefitPeriod: ListItemResource;
    complianceLevel: number;
    creditTypes: ListItemResource[];
    debtPerMilleSumAssured: number;
    declined: boolean;
    deferredPeriod: number;
    exclusionChoice: ExclusionChoiceResource;
    exclusions: ExclusionsResource[];
    expiryAge: number;
    isExclusionChoiceEnabled: boolean;
    isReviewed: boolean;
    isRisk: boolean;
    label: string;
    lienOnPolicy: ListItemResource;
    manualUnderwritingRequired: boolean;
    mibCode: string;
    mortalityClass: ListItemResource;
    negativePremiumLoading: number;
    occupationClass: ListItemResource;
    policyConditions: ListItemResource[];
    postponePeriod: number;
    premiumLoading: number;
    relatedEvidence: ListItemResource;
    riskFactor: number;
    sumAssuredLoading: number;
    termedNegativePremiumLoadings: TermedLoadingResource[];
    termedPremiumLoadings: TermedLoadingResource[];
    termedSumAssuredLoadings: TermedLoadingResource[];
    tests: RequirementResource[];
    triggers: ListItemResource[];
    underwritingStatus: ListItemResource;
    useSmokerRates: boolean;
}

export class DisclosurePhysicianResource extends ExpandedHalResource {
    disclosureIdentifier: InterviewDisclosureIdentifier;
    lastVisitDateExplicitlyUnknown: boolean;
    lastVisitMonth: number;
    lastVisitYear: number;
    physicianIdentifier: PhysicianResourceIdentifier;
    primaryForDisclosure: boolean;
}

export class EntityDefinitionResource extends ExpandedHalResource {
    alternativeFulfillers: ListItemResource[];
    backupFulfiller: ListItemResource;
    entityName: string;
    isEvidenceSharingAllowed: boolean;
    isMandatory: boolean;
    isManualSharingOnly: boolean;
    isMultipleInstancesAllowed: boolean;
    isOrderApprovalRequired: boolean;
    isRequiresDAP: boolean;
    isStageEntity: boolean;
    parentEntityName: string;
    phase: number;
    preferredFulfiller: ListItemResource;
    processingType: StageDataAccessType;
    properties: { [index: string]: string };
    stageDescription: string;
    stageType: StageType;
}

export class ExclusionChoiceResource {
    choice: ListItemResource;
    exclusion: ListItemResource;
    premiumLoading: number;
    sumAssuredLoading: number;
}

export class ListItemResource {
    code: string;
    description: string;
}

export class ExclusionsResource extends ListItemResource {
    term: ListItemResource;
}

export class InterviewUrlResource extends ExpandedHalResource {
    interviewURL: string;
}

export class LifeDecisionResource extends ExpandedHalResource {
    decisionsPerRisk: RiskBasedDecisionResource[];
}

export class LifeResource extends ExpandedHalResource {
    fullName: string;
    hasAttachments: boolean;
    hasPrimaryPhysician: boolean;
    lifeIdentifier: string;
    lifeInstance: string;
    riskTypes: ListItemResource[];
}

export class ListDefinitionResource extends ExpandedHalResource {
    listItems: ListItemResource[];
    listName: string;
}

export class LoadingForCategoryResource {
    category: ListItemResource;
    loading: number;
}

export class PhysicianResource extends ExpandedHalResource {
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: ListItemResource;
    email: string;
    fax: string;
    name: string;
    phone: string;
    source: PhysicianAdditionSource;
    speciality: string;
    state: ListItemResource;
    stateString: string;
    uuid: string;
    zip: string;
}

export class PicklistQuestionMeta {
    picklistItems: string[];
    picklistSearchEnabled: boolean;
    picklistSearchText: string;
    pickListNoneOfTheAboveVisible: boolean;
}

export class PrimaryPhysicianResource extends ExpandedHalResource {
    lastVisitDateExplicitlyUnknown: boolean;
    lastVisitMonth: number;
    lastVisitReason: ListItemResource;
    lastVisitReasonOther: string;
    lastVisitYear: number;
    physicianIdentifier: PhysicianResourceIdentifier;
    physicianExpected: boolean;
}

export class QuestionPageResource extends ExpandedHalResource {
    code: string;
    properties: { [index: string]: string };
    sections: QuestionSectionResource[];
    text: string;
}

export class QuestionPagesResource extends ExpandedHalResource {
    pages: QuestionPageResource[];
}

export class QuestionSectionResource extends ExpandedHalResource {
    baseQuestions: ScreensQuestionResource[];
    code: string;
    isImplicit: boolean;
    properties: { [index: string]: string };
    text: string;
}

export class ReflexiveQuestionResource extends ExpandedHalResource {
    answerText: string;
    answerType: ReflexiveAnswerType;
    answerValue: string;
    dateGranularity: DateElement;
    options: string[];
    properties: { [index: string]: string };
    questionText: string;
    code?: string;
    triggeredAliases: string[];
    picklistQuestionMeta: PicklistQuestionMeta;
}

export class RequirementResource extends ListItemResource {
    fulfiller: ListItemResource;
}

export class RiskBasedDecisionResource {
    _embedded: { [index: string]: ResourceSupport[] };
    _links: Link[];
    ageAdjustment: number;
    authorizationLevel: number;
    benefitPeriod: ListItemResource;
    complianceLevel: number;
    creditTypes: ListItemResource[];
    debtPerMilleSumAssured: number;
    decisionByCategoryClass: DecisionByClassResource[];
    declined: boolean;
    deferredPeriod: number;
    exclusions: ExclusionsResource[];
    expiryAge: number;
    faceAmount: number;
    improved: boolean;
    improvedFaceAmount: number;
    lienOnPolicy: ListItemResource;
    manualUnderwritingRequired: boolean;
    mortalityClass: ListItemResource;
    mortalityClassOriginal: ListItemResource;
    negativePremiumLoading: number;
    occupationClass: ListItemResource;
    originalFaceAmount: number;
    policyConditions: ListItemResource[];
    postponePeriod: number;
    premiumLoading: number;
    premiumLoadingOriginal: number;
    programs: ListItemResource[];
    resultType: ResultType;
    riskFactor: number;
    riskType: ListItemResource;
    sumAssuredLoading: number;
    sumAssuredLoadingOriginal: number;
    termedNegativePremiumLoadings: TermedLoadingResource[];
    termedPremiumLoadings: TermedLoadingResource[];
    termedSumAssuredLoadings: TermedLoadingResource[];
    termedSumAssuredLoadingsOriginal: TermedLoadingResource[];
    tests: RequirementResource[];
    triggers: ListItemResource[];
    underwritingStatus: ListItemResource;
    useSmokerRates: boolean;
}

export class RiskBasedUnderwritingResultResource {
    _embedded: { [index: string]: ResourceSupport[] };
    _links: Link[];
    ageAdjustment: number;
    authorizationLevel: number;
    benefitPeriod: ListItemResource;
    complianceLevel: number;
    creditTypes: ListItemResource[];
    debtPerMilleSumAssured: number;
    declined: boolean;
    deferredPeriod: number;
    exclusions: ExclusionsResource[];
    expiryAge: number;
    lienOnPolicy: ListItemResource;
    manualUnderwritingRequired: boolean;
    mortalityClass: ListItemResource;
    negativePremiumLoading: number;
    occupationClass: ListItemResource;
    policyConditions: ListItemResource[];
    postponePeriod: number;
    premiumLoading: number;
    premiumLoadingsByCategory: LoadingForCategoryResource[];
    riskFactor: number;
    riskType: ListItemResource;
    sumAssuredLoading: number;
    sumAssuredLoadingsByCategory: LoadingForCategoryResource[];
    termedNegativePremiumLoadings: TermedLoadingResource[];
    termedPremiumLoadings: TermedLoadingResource[];
    termedSumAssuredLoadings: TermedLoadingResource[];
    tests: RequirementResource[];
    triggers: ListItemResource[];
    underwritingStatus: ListItemResource;
    useSmokerRates: boolean;
}

export class ScreensQuestionResource extends ExpandedHalResource {
    answerRequiresAction: boolean;
    answerText: string;
    answerType: QuestionAnswerType;
    answerValue: string;
    baseQuestionHelp: string;
    caseDataQuestionMeta: CaseDataQuestionMeta;
    category: ListItemResource;
    clarifyingQuestion: boolean;
    code: string;
    conditionalQuestionMeta: ConditionalQuestionMeta;
    disclosureSource: DisclosureSource;
    disclosures: InterviewDisclosureIdentifier[];
    linkedAlias: string;
    parentConditionalQuestions: BaseQuestionIdentifier[];
    picklistQuestionMeta: PicklistQuestionMeta;
    properties: { [index: string]: string };
    questionText: string;
    questionType: QuestionType;
    questionsImpactedByAnswerChange: BaseQuestionIdentifier[];
    triggeredDisclosures: InterviewDisclosureIdentifier[];
    visible: boolean;
    searchingPicklistDisclosure: boolean;
    errorCode?: string;
    message?: string;
    invalid: boolean;
}

export class TermedLoadingResource {
    loading: number;
    term: ListItemResource;
}

export class UnderwritingResultsResource extends ExpandedHalResource {
    autoResultsPerRiskType: RiskBasedUnderwritingResultResource[];
    manualResultsPerRiskType: RiskBasedUnderwritingResultResource[];
}
